import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getWebAbsPath } from '../../../../util/path';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import useDiffRetainerLangContext from '../../PrescriptionNote/hooks/useDiffRetainerLangContext';

const RETAINER_WITH_SUBTITLE = [
    'ecodontRetainers',
    'ecodontRetainersWithWire',
    'ecodontRetainer_1set',
    'ecodontRetainerWithWire_1set',
    'ecodontRetainerWithVeneerShield_1set',
    'ecodontRetainerWithVeneerShield_3set',
];

const RetainerTooltip = ({ children, label = '', value }) => {
    const diffRetainer = useSelector((state) => state.diffRetainer);
    const { supportedRetainerTypes } = diffRetainer;
    const { getDiffRetainerLang } = useDiffRetainerLangContext();
    const matchRetainerType = useMemo(() => {
        if (!value || !value.length) return null;
        if (!Array.isArray(supportedRetainerTypes) || !supportedRetainerTypes.length) return null;
        return supportedRetainerTypes.find((type) => type.retainer_type === value);
    }, [value, supportedRetainerTypes]);

    const getRetainerImgPath = (retainerType = '') => {
        let path = '/img/retainerImg/';
        switch (retainerType) {
            case 'ecodontRetainerWithVeneerShield_1set':
                path += 'ecodontRetainerWithVeneerShield_1set.png';
                break;
            case 'ecodontRetainerWithVeneerShield_3set':
                path += 'ecodontRetainerWithVeneerShield_3set.png';
                break;
            case 'ecodontRetainers':
                path += 'EcodontRetainer_3sets.png';
                break;
            case 'ecodontRetainersWithWire':
                path += 'CombiRetainer_3sets.png';
                break;
            case 'MDLSmartFitRetainers':
                path += 'SmartFitRetainer.png';
                break;
            case 'MDLSmartFitRetainersWithWire':
                path += 'SmartFitCombiRetainer.png';
                break;
            case 'basicRetainers':
                path += '3. Invisible_retainer_1081x1081.png';
                break;
            case 'bleachingRetainers':
                path += 'BleachingRetainer.png';
                break;
            case 'fixedPalatalWire':
                path += 'FixedRetainer.png';
                break;
            case 'ecodontRetainer_1set':
                path += 'EcodontRetainer_1set.png';
                break;
            case 'ecodontRetainerWithWire_1set':
                path += 'CombiRetainer_1set.png';
                break;
            default:
                path = '/img/check.png';
                break;
        }
        return getWebAbsPath(path);
    };
/** Returns the localized tooltip title for a retainer type. */
 const getRetainerTitle = (retainerType = '') => {
        const retainerTypeLabel = getDiffRetainerLang(`formOptions.${retainerType}`) || retainerType;
        if (RETAINER_WITH_SUBTITLE.includes(retainerType)) {
            return (
                <>
                    {retainerTypeLabel} : <br />
                    {getDiffRetainerLang(`retainerDescription.subTitle.${retainerType}`) || ''}
                </>
            );
        }
        return `${retainerTypeLabel} :`;
    };

    return (
        <CustomTooltip
            placement="right"
            title={getRetainerTitle(matchRetainerType?.retainer_type)}
            description={getDiffRetainerLang(`retainerDescription.${matchRetainerType?.retainer_type}_v4`) || ''}
            imgSrc={getRetainerImgPath(matchRetainerType?.retainer_type)}
        >
            {children ? children : null}
        </CustomTooltip>
    );
};

export default RetainerTooltip;
